import raw from '../models-data.json'
import type { Model } from './types'

export const models = raw.models as unknown as Model[]
export const DATA_DATE = raw.meta.dataAsOf
export const rawScenarios = raw.scenarios

export const channelLabels: Record<string, string> = {
  'workbuddy-builtin': 'WorkBuddy 内置',
  'official-api': '官方 API',
  'official-subscription': '官方订阅',
  relay: '第三方中转',
}

export const sceneLabels = {
  code: '写代码', writing: '写作与分析', vision: '看图与 UI', report: '长报告',
  batch: '批量处理', reasoning: '疑难攻坚', realtime: '实时信息',
} as const
